export * from "./AfterSend"
export * from "./Inline/DemoForm"
export * from "./Inline/DemoInlineSection"
export * from "./Inline/DemoInlineSectionWithPic"

// Событие на демо
export const demoEvent = "Заполнил форму на демо"
export const startEvent = "Начал заполнять форму на демо"

export function getCookie(name: string): string | null {
  if (typeof document !== "undefined") {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`))
    return matches ? decodeURIComponent(matches[1]) : null
  }
  return null
}

// Пиксели
export const pixels = ({ isAudit = false }: { isAudit?: boolean } = {}) => {
  if (!+process.env.GATSBY_DASHLY) {
    if (typeof VK === "object") {
      VK.Goal("conversion")
    }
    if (typeof ym === "function") {
      // С формы аудита демо-цель не шлём: у аудита свои цели в trackDemoSubmitGoals.
      if (!isAudit) {
        ym(25430054, "reachGoal", "get_demo")
      }

      // submit_all шлёт trackDemoSubmitGoals, а все вызовы pixels() идут с ним в паре.
      // Раньше цель уходила из обоих мест, и достижения цели удваивались на каждой отправке.
    }
  }
}
